export const MAX_LETTER_LENGTH = 1000;
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 МБ
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const LOADING_MS = 900; // имитация загрузки файла на сервер

export const DOC_EXTS = ['pdf', 'doc', 'docx'];
export const VIDEO_EXTS = ['mp4', 'mov', 'avi', 'webm'];
